(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sale-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function parseEnd(str) {
    if (!str) { return null; }
    var s = String(str).trim().replace(' ', 'T');
    var d = new Date(s);
    return isNaN(d.getTime()) ? null : d;
  }

  function headerOffset(el) {
    var sels = ['sticky-header', '.shopify-section-group-header-group', '.site-header', '.header-wrapper', 'header.header', '#shopify-section-header', '#header', 'header'];
    for (var i = 0; i < sels.length; i++) {
      var h = document.querySelector(sels[i]);
      if (h && h !== el && !h.contains(el) && !el.contains(h)) {
        var off = 0;
        var nodes = [h].concat(Array.prototype.slice.call(h.querySelectorAll('*')));
        for (var j = 0; j < nodes.length; j++) {
          var pos = getComputedStyle(nodes[j]).position;
          if (pos === 'fixed' || pos === 'sticky') {
            off = Math.max(off, nodes[j].getBoundingClientRect().height);
          }
        }
        return off;
      }
    }
    return 0;
  }

  function initBar(bar) {
    if (bar.dataset.sbInit === '1') { return; }
    bar.dataset.sbInit = '1';

    var hrsEl = bar.querySelector('.t-hrs');
    var minsEl = bar.querySelector('.t-mins');
    var secsEl = bar.querySelector('.t-secs');
    var hideExpired = bar.dataset.hideExpired === 'true';

    var end = parseEnd(bar.dataset.end);
    var usingFallback = false;
    if (!end || end.getTime() <= Date.now()) {
      var hrs = parseFloat(bar.dataset.fallbackHours) || 0;
      if (hrs > 0) {
        end = new Date(Date.now() + hrs * 3600 * 1000);
        usingFallback = true;
      }
    }
    if (!end) { return; }

    if (bar.classList.contains('sale-bar--sticky')) {
      var wrap = bar.closest('.shopify-section') || bar;
      wrap.style.position = 'sticky';
      wrap.style.zIndex = '50';
      var setTop = function () { wrap.style.top = headerOffset(wrap) + 'px'; };
      setTop();
      window.addEventListener('resize', setTop);
      window.addEventListener('load', setTop);
    }

    function tick() {
      var remaining = end.getTime() - Date.now();
      if (remaining <= 0) {
        remaining = 0;
        if (hideExpired && !usingFallback) {
          var w = bar.closest('.shopify-section') || bar;
          w.style.display = 'none';
        }
        clearInterval(bar._sbIv);
      }
      var total = Math.floor(remaining / 1000);
      var h = Math.floor(total / 3600);
      var m = Math.floor((total % 3600) / 60);
      var sec = total % 60;
      if (hrsEl) { hrsEl.textContent = pad(h); }
      if (minsEl) { minsEl.textContent = pad(m); }
      if (secsEl) { secsEl.textContent = pad(sec); }
    }

    tick();
    bar._sbIv = setInterval(tick, 1000);
  }

  function initAll(root) {
    var scope = root || document;
    var bars = scope.querySelectorAll('.sale-bar');
    for (var i = 0; i < bars.length; i++) { initBar(bars[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var bars = e.target.querySelectorAll('.sale-bar');
    for (var i = 0; i < bars.length; i++) { if (bars[i]._sbIv) { clearInterval(bars[i]._sbIv); } }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
